/*
* required polyfills
*/

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
//mport "core-js";
//mport 'core-js/features/symbol'
//mport 'core-js/features/object'
//mport 'core-js/features/function'
//mport 'core-js/features/parse-int'
//mport 'core-js/features/parse-float'
//mport 'core-js/features/number'
//mport 'core-js/features/math'
//mport 'core-js/features/string'
//mport 'core-js/features/date'
//mport 'core-js/features/array'
//mport 'core-js/features/regexp'
//mport 'core-js/features/map'
//mport 'core-js/features/weak-map'
//mport 'core-js/features/set'
//mport 'core-js/features/set/map';

/** IE10 and IE11 requires the following for the Reflect API. */
//mport 'core-js/features/reflect';

/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
//mport 'core-js/features/reflect'

// CustomEvent() constructor functionality in IE9, IE10, IE11
(function () {

  if ( typeof window.CustomEvent === "function" ) return false

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent( 'CustomEvent' )
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail )
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
